import React from 'react';

import { OnboardingMessage } from './OnboardingMessage';
import { OnboardingModal } from './OnboardingModal';

const Onboarding = () => {
  return (
    <>
      <OnboardingMessage />
      <OnboardingModal />
    </>
  );
};

export default Onboarding;
